<template>
  <div class="common-page staff-management">
    <div class="staff-left">
      <el-input
        class="tree-search"
        v-model="companyName"
        style="width: 100%"
        clearable
        @change="handleChangeCompanyName"
        placeholder="请输入部门名称">
        <i class="el-icon-search" slot="prefix"></i>
      </el-input>
      <div class="tree-box">
        <el-tree
          ref="tree"
          :check-on-click-node="true"
          :expand-on-click-node="false"
          default-expand-all
          :data="deptData"
          highlight-current
          :current-node-key="currentNodeKey"
          :props="defaultProps"
          node-key="deptId"
          @node-click="handleNodeClick"
          :filter-node-method="filterNode"></el-tree>
      </div>
      <div class="add-dept" @click="addDept">新增部门</div>
    </div>
    <div class="staff-right">
      <div class="search-form-box">
        <div class="top-box">
          <div class="top-box-left">
            <el-image :src="companyImage" class="company-image"></el-image>
            <div class="company-box">
              <span :class="index === 0 ? 'name' : 'sub-name'" v-for="(item, index) in parentDeptInfo" :key="index">
                {{ item.deptName }}
              </span>
              <el-image :src="treeImage" class="tree-image"></el-image>
            </div>
          </div>
          <div class="top-box-right">
            <span class="box-1" @click="editDept">编辑部门</span>
            <span class="box-1" @click="deleteDept">删除部门</span>
          </div>
        </div>
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="6">
              <el-form-item label="员工姓名/手机号">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="searchForm.keyword"
                  autocomplete="off"
                  placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="岗位标签">
                <el-select style="width: 100%" clearable v-model="searchForm.userType" placeholder="请选择">
                  <el-option
                    v-for="item in $dict.jobLabelOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="角色">
                <el-select style="width: 100%" clearable v-model="searchForm.roleId" placeholder="请选择">
                  <el-option
                    v-for="item in roleData"
                    :key="item.roleId"
                    :label="item.roleName"
                    :value="item.roleId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
                <el-button type="primary" @click="addStaff()">添加员工</el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
      <div class="custom-table-box">
        <custom-table
          :data="tableData"
          :column="tableColumn"
          :total="tableOptions.total"
          :loading="tableOptions.loading"
          :page="tableOptions.pageNumber"
          :size="tableOptions.pageSize"
          :selection="false"
          @pagination="handleSizeChange">
          <template v-slot:roles="{ row }">
            <template v-if="row.roles && row.roles.length > 0">
              <span v-for="(item, index) in row.roles">
                {{ item.roleName }}
                <span v-if="index !== row.roles.length - 1">、</span>
              </span>
            </template>
          </template>
          <template v-slot:userType="{ row }">
            {{ getLocalLabel("jobLabel", row.userType) }}
          </template>
          <template v-slot:operation="{ row }">
            <span class="operate-btn" @click.stop="editStaff(row)">编辑</span>
            <span class="operate-btn" @click="handleDelete(row.userId, '确定要删除此员工吗？')">删除</span>
            <span class="operate-btn" @click.stop="handleResetPass(row)">重置密码</span>
          </template>
        </custom-table>
      </div>
    </div>
    <!--    添加或编辑-->
    <addOrEditDept ref="addOrEditDept"></addOrEditDept>
    <addOrEditStaff ref="addOrEditStaff"></addOrEditStaff>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import addOrEditDept from "./addOrEditDept.vue";
import addOrEditStaff from "./addOrEditStaff.vue";
import { deleteInfo, getPage, resetPass } from "./api";
import tableMixin from "@/mixin/tableMixin";
import { deleteDept, getAllTree } from "@/views/commonApi";
import { getLocalLabel } from "@/utils/localDict";

export default {
  name: "StaffManagement",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    addOrEditDept,
    addOrEditStaff,
  },
  data() {
    return {
      companyName: "",
      companyImage: require("@/assets/imgs/company.png"),
      treeImage: require("@/assets/imgs/tree.png"),
      haveRole: true,
      haveDept: false,
      getTableMethod: getPage,
      deleteMethod: deleteInfo,
      isImmediatelyGetData: false,
      searchForm: {
        deptId: "",
        keyword: "",
        roleId: "",
      },
      defaultProps: {
        children: "children",
        label: "deptName",
        value: "deptId",
      },
      selectedDeptInfo: {
        deptId: "",
      }, // 被选中的部门
      parentDeptInfo: [], // 被选中的父级部门
      selectedKeys: [], // 被选中的某一项
      tableColumn: [
        {
          label: "员工姓名",
          prop: "username",
          show: true,
        },
        {
          label: "手机号码",
          prop: "phone",
          show: true,
        },
        {
          label: "所属部门",
          prop: "deptName",
          show: true,
        },
        {
          label: "岗位标签",
          prop: "userType",
          scopeStatus: true,
          show: true,
        },
        {
          label: "系统角色",
          prop: "roles",
          scopeStatus: true,
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          width: "200px",
          fixed: "right",
          scopeStatus: true,
          show: true,
        },
      ],
      currentNodeKey: "",
    };
  },
  watch: {
    companyName(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.getDeptData();
  },
  mounted() {},
  methods: {
    handleReset() {
      this.searchForm.keyword = "";
      this.searchForm.roleId = "";
      this.searchForm.userType = "";
      this.tableOptions.currentPage = 1;
      this.searchPage();
    },
    getLocalLabel,
    getDeptData() {
      getAllTree().then((res) => {
        if (res.code === 200) {
          this.deptData = res.data;
          if (this.deptData && this.deptData.length > 0) {
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(this.deptData[0].deptId);
            });
            this.handleSelectNode(this.deptData[0]);
          }
        }
      });
    },
    setTree() {
      this.getDeptData();
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(this.selectedKeys);
      });
    },
    handleSelectNode(node) {
      if (this.selectedDeptInfo.deptId === node.deptId) {
        return;
      } else {
        this.selectedDeptInfo = node;
      }
      this.searchForm.deptId = this.selectedDeptInfo.deptId;
      this.parentDeptInfo = this.findParentPath(this.deptData, node.deptId);
      this.getTableData();
    },
    handleChangeCompanyName(node) {},
    handleNodeClick(node) {
      this.handleSelectNode(node);
    },
    addDept() {
      this.$refs.addOrEditDept.init(this.selectedDeptInfo, "add");
    },
    editDept() {
      this.$refs.addOrEditDept.init(this.selectedDeptInfo, "edit");
    },
    addStaff() {
      this.$refs.addOrEditStaff.init(this.roleData);
    },
    editStaff(row) {
      this.$refs.addOrEditStaff.init(this.roleData, row);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.deptName.indexOf(value) !== -1;
    },
    deleteDept() {
      this.$confirm(`确定删除此部门？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        deleteDept(this.searchForm.deptId).then((res) => {
          if (res.code === 200) {
            this.getDeptData();
          }
        });
      });
    },
    handleResetPass(row) {
      this.$confirm(`确定重置此用户密码？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        resetPass({ userId: row.userId }).then((res) => {
          if (res.code === 200) {
            this.$message.success("密码重置成功");
          }
        });
      });
    },
    findParentPath(treeData, deptId) {
      let path = [];
      function traverse(nodes, currentPath) {
        for (const node of nodes) {
          const newPath = [...currentPath, node]; // 创建新路径，避免引用问题

          if (node.deptId === deptId) {
            path = newPath; // 找到目标，保存路径
            return true; // 返回true停止遍历
          }

          if (node.children && node.children.length > 0) {
            if (traverse(node.children, newPath)) {
              return true; // 如果在子节点中找到，提前退出
            }
          }
        }
        return false;
      }
      traverse(treeData, []);
      return path;
    },
  },
};
</script>
<style lang="scss" scoped>
.staff-management {
  display: flex;
  box-sizing: border-box;
  flex-direction: row;
  padding: 0.2rem;
  .staff-left {
    width: 3rem;
    height: 100%;
    background-color: #ffffff;
    flex-shrink: 0;
    border-radius: 0.08rem;
    padding: 0.2rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .tree-search {
      flex-shrink: 0;
    }
    .tree-box {
      flex: 1;
      overflow-y: auto;
      padding-top: 0.1rem;
    }
    .add-dept {
      width: 100%;
      height: 0.32rem;
      background-color: #eaf1ff;
      border-radius: 0.08rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.14rem;
      color: #1269ff;
      cursor: pointer;
    }
  }
  .staff-right {
    flex: 1;
    height: 100%;
    background-color: #ffffff;
    border-radius: 0.08rem;
    margin-left: 0.2rem;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .custom-table-box {
      padding: 0 0.1rem 0.2rem;
    }
    .top-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0.1rem 0 0.3rem;
      .top-box-left {
        display: flex;
        align-items: center;
        .company-image {
          width: 0.2rem;
          height: 0.2rem;
        }
        .company-box {
          display: flex;
          align-items: center;
          .name {
            color: #000000;
            font-size: 0.18rem;
            padding-left: 0.1rem;
            padding-right: 0.1rem;
          }
          .sub-name {
            color: #000000;
            font-size: 0.14rem;
          }
          .tree-image {
            width: 0.2rem;
            height: 0.2rem;
            margin-left: 0.04rem;
          }
        }
      }
      .top-box-right {
        .box-1 {
          color: #1269ff;
          cursor: pointer;
          position: relative;
          padding-right: 0.2rem;
          &:hover {
            text-decoration: underline;
          }
        }
        .box-1:before {
          position: absolute;
          content: "";
          right: 0.1rem;
          top: 0.04rem;
          width: 0.01rem;
          height: 0.12rem;
          background-color: #d9d9d9;
        }
        .box-1:nth-last-of-type(1) {
          padding-right: 0.1rem;
        }
        .box-1:nth-last-of-type(1):before {
          display: none;
        }
      }
    }
  }
  .sub-name {
    padding-right: 0.14rem;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      right: 0.05rem;
      width: 0.02rem;
      height: 0.14rem;
      background-color: #999999;
    }
  }
  .sub-name:nth-last-of-type(1) {
    padding-right: 0;
  }
  .sub-name:nth-last-of-type(1)::before {
    display: none;
  }
}
</style>
